import { bech32 } from "bech32";
import { Buffer } from "buffer";
import { Address, toHex } from "viem";

export function convertHexToBech32(hexAddress: Address, prefix = "gala") {
  const bf = Buffer.from(hexAddress.slice(2), "hex");
  const words = bech32.toWords(bf);

  return bech32.encode(prefix, words);
}

export function convertBech32ToHex(bech32Address: string, currPrefix = "gala") {
  const { prefix, words } = bech32.decode(bech32Address);
  if (prefix !== currPrefix) {
    throw Error("Invalid address format");
  }

  return toHex(Buffer.from(bech32.fromWords(words)));
}
